<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitleExpire"
  [nzClosable]="!isVisibleModal"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContentExpire"
  [nzFooter]="modalFooterExpire"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitleExpire>
  </ng-template>

  <ng-template #modalContentExpire>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img loading="lazy" src="./../../../assets/images/wait-2.jpg" alt="" style="height: 220px;">
      <p class="text-info mt-xlg">
        <i nz-icon nzType="warning" nzTheme="outline" class="mr-xxs"></i>
        Espera. ¿Tuviste problemas con tu suscripción?
      </p>
    </div>
  </ng-template>

  <ng-template #modalFooterExpire>
    <div class="container-footer-modal" [@fadeInAnimation]>
      <button
        style="margin-right: 5px;"
        class="btn-default"
        nz-button nzType="default">
        <i nz-icon nzType="whats-app" nzTheme="outline"></i>
        CONTACTAR A SOPORTE</button>
      <button
        (click)="onEmitSubscribe()"
        nz-button nzType="primary">
        <i nz-icon nzType="retweet" nzTheme="outline"></i>
        INTENTARLO DE NUEVO</button>
    </div>
  </ng-template>
</nz-modal>
